import { ObjectDataRecord, TimeLineDTOType } from '@types'
import { getPathString } from '@helpers'
import { get } from 'lodash'
import { getDynamicColumnFieldKey } from '@components/TimeLineGrid/helpers/getDynamicColumnFieldKey'

type Props = {
  config: TimeLineDTOType,
  objectXData: ObjectDataRecord[]
  columnsObjectData: ObjectDataRecord[]
}

export const getFilteredColumnsObjectDataByObjectXData = (props: Props) => {
  const { config, objectXData, columnsObjectData } = props

  const linkToColumnsObjectPath = config.objectX?.linkToColumnsObject
    ? getPathString(config.objectX?.linkToColumnsObject)
    : ''

  const columnsObjectIdsSet = new Set()

  objectXData.forEach(item => {
    if (linkToColumnsObjectPath) {
      columnsObjectIdsSet.add(get(item, linkToColumnsObjectPath))
    }
  })

  return columnsObjectData.filter(item => {
    const columnKey = getDynamicColumnFieldKey(item, config.objectX.fieldFromColumnsObjectToLink)

    return columnsObjectIdsSet.has(columnKey)
  })
}